import { DateTimeUtil } from "./date-time-util";

export class IdadeUtil {

  public static ordenarPorIdade(dtNascA: Date, dtNascB: Date): number {
    if ( !dtNascB ) {
      return 1;
    }
    else if ( !dtNascA ) {
      return -1;
    }

    if ( !(dtNascA instanceof Date) ) {
      dtNascA = DateTimeUtil.stringIsoToDate(dtNascA);
    }

    if ( !(dtNascB instanceof Date) ) {
      dtNascB = DateTimeUtil.stringIsoToDate(dtNascB);
    }

    if ( dtNascA > dtNascB ) {
      return 1;
    }
    else if ( dtNascA < dtNascB ) {
      return -1;
    }

    return 0;
  }

  public getIdadeDescritiva(dataNascimento: Date): string {
    try {
      if ( !dataNascimento ) {
        return '';
      }
      if ( !(dataNascimento instanceof Date) ) {
        if ( (''+dataNascimento).length === 10 ) {
          dataNascimento = new DateTimeUtil().stringIsoToDate(dataNascimento);
        }
      }
  
      const today = new Date();
  
      let idade = today.getFullYear() - dataNascimento.getFullYear();
      let m = today.getMonth() - dataNascimento.getMonth();
      
      if (m < 0 || (m === 0 && today.getDate() < dataNascimento.getDate())) {
        idade--;
      }
  
      if ( idade === 0 ) {
        m = Math.abs(m);
        if ( m === 1 ) {
          return '1 mês';
        }
        else {
          return m + ' meses';
        }
      }
      else if ( idade === 1 ) {
        return '1 ano';
      }
      else {
        return idade + ' anos';
      }
    }
    catch (e) {
      return 'Erro: ' + e.message;
    }
}

}